import { ClassMethods } from "@/types/class.type";

export function getClassFunctions<T>(instance: T): ClassMethods<T> {
    const methods = Object.getOwnPropertyNames(Object.getPrototypeOf(instance))
        .filter((key: any) => {
            const value = instance[key as keyof T];
            return typeof value === "function";
        })
        .reduce((acc: any, key: any) => {
            const value = instance[key as keyof T];
            if (typeof value === "function") {
                acc[key as keyof T] = value.bind(instance);
            }
            return acc;
        }, {} as ClassMethods<T>);

    return methods;
}
